module.exports = __webpack_public_path__ + "static/media/webCastIcon.cf8756fe.png";